import React from 'react';
import { PersonalDetailType } from '../CommonTypes';
import { SummaryItem } from './Summary';
import { useTranslation } from 'react-i18next';

export type SummaryPersonalDetailsProps = {
  personalDetail: PersonalDetailType;
  isConfirmationScreen: boolean;
  culture: string;
  phoneNumberLabel?: string;
};

const SummaryPersonalDetails = ({
  personalDetail,
  isConfirmationScreen,
  culture,
  phoneNumberLabel
}: SummaryPersonalDetailsProps): JSX.Element => {
  const { t } = useTranslation();

  const dateofBirth =
    personalDetail.dateOfBirth !== undefined
      ? personalDetail.dateOfBirth?.toLocaleDateString(culture, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        })
      : '';

  const titleLabel = t('summary.title-label');
  const firstNameLabel = t('summary.first-name-label');
  const surnameLabel = t('summary.surname-label');
  const dateOfBirthLabel = t('summary.date-of-birth-label');
  const emailAddressLabel = t('summary.email-address-label');
  const phoneNumberText = phoneNumberLabel || t('summary.phone-number-label');
  const addressLine1 = t('summary.address-line1');
  const addressLine2 = t('summary.address-line2');
  const cityLabel = t('summary.city-label');
  const postCodeLabel = t('summary.post-code-label');
  const countryLabel = t('summary.country-label');
  const countyLabel = t('summary.county-label');

  const getCountryName = () => {
    switch (personalDetail.addressDetails.country) {
      case 'GBR':
        return t('countries.united-kingdom');
      case 'DEG':
        return t('countries.germany');
      case 'AUT':
        return t('countries.austria');
      default:
        return t('countries.united-kingdom');
    }
  };

  return (
    <div className='flex-column'>
      <SummaryItem label={titleLabel} value={personalDetail.title} />
      <SummaryItem label={firstNameLabel} value={personalDetail.firstName} />
      <SummaryItem label={surnameLabel} value={personalDetail.surname} />
      {!isConfirmationScreen && (
        <SummaryItem label={dateOfBirthLabel} value={dateofBirth} />
      )}
      <SummaryItem label={emailAddressLabel} value={personalDetail.email} />
      <SummaryItem label={phoneNumberText} value={personalDetail.phone} />
      <SummaryItem
        label={addressLine1}
        value={personalDetail.addressDetails.addressLine1 || ''}
      />
      <SummaryItem
        label={addressLine2}
        value={personalDetail.addressDetails.addressLine2 || ''}
      />
      <SummaryItem
        label={cityLabel}
        value={personalDetail.addressDetails.townOrCity || ''}
      />
      <SummaryItem
        label={countyLabel}
        value={personalDetail.addressDetails.region || ''}
      />
      <SummaryItem label={countryLabel} value={getCountryName()} />
      <SummaryItem
        label={postCodeLabel}
        value={personalDetail.addressDetails.postCode || ''}
      />
    </div>
  );
};

export default SummaryPersonalDetails;
